
<div class="flat_flag_row">
    <div class="row align-items-center">
        <div class="col col-1 text-center">
            <RiskLevelDumpling :value="flag.risk" :level="versionRiskLevel(flag, version)" />
        </div>
        <div class="col col-3 group">
            {{ flag.flag_type_group_name }}&nbsp;
            <a :href="flagUrl(flag.flag_type_group_documentation_url)" target="_blank" v-if="flag.flag_type_group_documentation_url">
                <b-icon-question-circle
                    font-scale="0.95"
                    variant="dark"
                    class="ml-1"
                />
            </a>
        </div>
        <div class="col">
            <h4 class="name">
                {{ flag.flag_type_name }}&nbsp;
                <a :href="flagUrl(flag.flag_type_documentation_url)" target="_blank" v-if="flag.flag_type_documentation_url">
                    <b-icon-question-circle
                        font-scale="0.95"
                        variant="dark"
                        class="ml-1"
                    />
                </a>
            </h4>
            <p v-if="flag.description" class="description">
                {{ flag.description }}
            </p>
        </div>
    </div>
</div>
